import { createFileRoute } from "@tanstack/react-router";
import AdminCodesPage from "@/admin/pages/codes";

export const Route = createFileRoute("/admin/codes/")({
  component: AdminCodesPage,
});
